/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';

import { textFontSize, textColor } from 'components/styles';

const styles = {
  content: css({
    fontSize: textFontSize.sm,
    width: '100%',
    color: textColor.subText01,
  }),
};

const FormHelp: React.FC<{
  content: string;
}> = ({ content }) => (
  <React.Fragment>
    <small css={styles.content} dangerouslySetInnerHTML={{ __html: content }} />
  </React.Fragment>
);

export default FormHelp;
